/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ score: NonNullable<unknown> }} Directory_Submit_Enrich_Result_ReadinessInputs */

const en_directory_submit_enrich_result_readiness = /** @type {(inputs: Directory_Submit_Enrich_Result_ReadinessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Agent-readiness ${i?.score}`)
};

const zh_directory_submit_enrich_result_readiness = /** @type {(inputs: Directory_Submit_Enrich_Result_ReadinessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Agent 就绪度 ${i?.score}`)
};

/**
* | output |
* | --- |
* | "Agent-readiness {score}" |
*
* @param {Directory_Submit_Enrich_Result_ReadinessInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_result_readiness = /** @type {((inputs: Directory_Submit_Enrich_Result_ReadinessInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Result_ReadinessInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_result_readiness(inputs)
	return zh_directory_submit_enrich_result_readiness(inputs)
});
export { directory_submit_enrich_result_readiness as "directory.submit.enrich.result.readiness" }